import script from "./RecollectionStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./RecollectionStatus.vue?vue&type=script&setup=true&lang=js"

import "./RecollectionStatus.vue?vue&type=style&index=0&id=4f5e9f07&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f5e9f07"]])

export default __exports__